import { LayoutGrid, PenTool, Trash2, Users } from 'lucide-react'

import { defineArea, defineModule } from '@/lib/module-routes'

import { canvasRoute } from './canvas-route'

import {
  canvasAllRoute,
  canvasCollectionRoute,
  canvasEditorRoute,
  canvasRedeemRoute,
  canvasSharedRoute,
  canvasTrashRoute,
} from './routes'

const canvasArea = defineArea({
  id: 'canvas',
  label: 'Canvas sections',
  product: 'canvas',
  route: canvasRoute,
})

declare module '@/lib/module-routes' {
  interface Areas {
    canvas: typeof canvasArea
  }
}

export const canvasModule = defineModule({
  routes: [
    canvasRoute,
    canvasAllRoute,
    canvasSharedRoute,
    canvasTrashRoute,
    canvasCollectionRoute,
    canvasRedeemRoute,
    canvasEditorRoute,
  ],
  products: [
    {
      id: 'canvas',
      label: 'Canvas',
      description: 'Draw and diagram together',
      icon: PenTool,
      order: 60,
      routes: [canvasRoute, canvasEditorRoute],
    },
  ],
  areas: [canvasArea],
  sections: {
    canvas: [{ id: 'canvas', label: 'Canvas', order: 10 }],
  },
  navigation: {
    canvas: [
      { to: '/$entityId/canvas', label: 'All drawings', icon: LayoutGrid, section: 'canvas', order: 10, exact: true },
      { to: '/$entityId/canvas/shared', label: 'Shared with me', icon: Users, section: 'canvas', order: 20, exact: true },
      { to: '/$entityId/canvas/trash', label: 'Trash', icon: Trash2, section: 'canvas', order: 30, exact: true },
    ],
  },
})
